
<wun-filter ngSkipHydration #filter></wun-filter>
<div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2 xl:gap-6 p-6 main">
  @for (artwork of artworks() || []; track artwork.id) {
    <div class="flex flex-col justify-between overflow-hidden gap-6 h-112" [class.opacity-60]="artwork.soldOut" #attach>
      @if (artwork.mainAttachment) {
        @let media = artwork.mainAttachment;
        <a class="relative flex h-full items-center overflow-hidden justify-center bg-slate-50" [routerLink]="'./' + artwork.id">
          <wun-media-render [attachTo]="attach" [showPreviewOverview]="true" [url]="'/artworks/' + artwork.id"
                            [media]="media" [medias]="artwork.attachments || []" [class.grayscale]="artwork.soldOut"/>
          @if (artwork.soldOut) {
            <span class="absolute top-2 left-2 bg-soldOut text-white text-xs font-bold uppercase px-2 py-1 rounded shadow">
              Sold Out
            </span>
          }
        </a>

      }

      <div class="font-bold">
        <a [routerLink]="'./' + artwork.id" class="text-xl font-thin">
          {{ artwork.name }}
        </a>
        <div>
      
          <a [routerLink]="'/artists/' + artwork.artist.id">
            @if (artwork.artistName) {
              {{artwork.artistName}}
            } @else {
              @if(artwork.artist.displayNamePreference === 'NICKNAME' && (artwork.artist.nickname || artwork.artist.username)) {
                {{ artwork.artist.nickname || artwork.artist.username }}
              } @else { 
              {{ artwork.artist.firstName }} {{ artwork.artist.lastName }}
              }
            }
          </a>
        </div>
        <div class="flex justify-between items-center">
          <div>
            {{ artwork.price | currency : 'EUR' : '' : '1.2-2' }} €
          </div>
          <div class="flex gap-3 items-center">
            <wun-like-button [onlyHeart]="true" [artworkId]="artwork.id" [likeId]="$any(artwork).likeId"
                             [likeCount]="artwork.wishesCount"/>
            <wun-add-to-cart [work]="artwork"></wun-add-to-cart>
          </div>
        </div>
      </div>
    </div>
  }
</div>

